import Api from "api/Api";
import Button from "components/button/Button";
import React, { useState } from "react";
import { useEffect } from "react";
import { compose } from "redux";
import enhancer from "./validator";
import Select from "react-select";

// let ImageArray = [];

const BannerForm = props => {
  const {
    handleBlur,
    errors,
    loading,
    touched,
    submitCount,
    onSubmit,
    values,
    action,
    setFieldValue,
    editedData,
    isStore,
    storeId,
    storeName,
    branchCount,
    deviceCount,
    banners,
    handleChange
  } = props;

  const [deviceList, setDeviceList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [imageData, setImageData] = useState([]);

  useEffect(() => {
    if (action === "edit" && editedData?.bannersResDTOSet?.length) {
      setImageData([...editedData?.bannersResDTOSet]);
    }
  }, [editedData]);

  // Load device list (used in individual mode)
  useEffect(() => {
    if (isStore) {
      Api.post(`/admin/store/devicelist?storeId=${storeId}`, {}).then(res => {
        setDeviceList(res.data.data);
      });
    } else {
      Api.get("/admin/device/deviceList", {}).then(res => {
        setDeviceList(res.data.data);
      });
    }
  }, [isStore, storeId]);

  // Load branch list (used in branch mode) — only when a store is in context
  useEffect(() => {
    if (storeId) {
      Api.post(`/admin/branch/store/list?storeId=${storeId}`)
        .then(res => {
          setBranchList(res.data.data || []);
        })
        .catch(() => setBranchList([]));
    }
  }, [storeId]);

  // useEffect(() => {
  //   if (editedData?.bannersResDTOSet) {
  //     const images = [];
  //     editedData.bannersResDTOSet.map((data) => images.push(data.bannerImage));
  //     setImageData([...images]);
  //   }
  // }, [editedData]);

  const getExtension = url => {
    const split = url.split(".");
    return split[split?.length - 1];
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span></span>;
    }
  };

  const imageHandler = e => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    const validFiles = files.filter(
      file => file.type.startsWith("image/") || file.type === "video/mp4"
    );
    if (!validFiles.length) return;

    const updated = [...imageData, ...validFiles];
    setImageData(updated);
    setFieldValue("banner", updated);
    e.target.value = "";
  };

  const handleSubmit = e => {
    e.preventDefault();
    const {
      values,
      isValid,
      handleSubmit: formikSubmit,
      setFieldError
    } = props;

    if (!editedData) {
      if (values.targetType === "individual") {
        const hasDevice = Array.isArray(values.device)
          ? values.device.length > 0
          : Boolean(values.device?.id);
        if (!hasDevice) {
          setFieldError("device", "Device is required");
          formikSubmit();
          return;
        }
      }
      if (values.targetType === "branch" && !values.branchId) {
        setFieldError("branchId", "Branch is required");
        formikSubmit();
        return;
      }
      if (values.targetType === "store" && !storeId) {
        setFieldError(
          "device",
          "Store context is required for store-wide banners"
        );
        formikSubmit();
        return;
      }
    }

    const hasBannerFiles = (values.banner || []).some(
      item => item instanceof File || item?.bannerId
    );
    if (!hasBannerFiles) {
      setFieldError("banner", "At least one banner image is required");
      formikSubmit();
      return;
    }

    if (isValid) {
      onSubmit(values, action);
    }
    formikSubmit();
  };

  return (
    <div>
      <form
        onSubmit={e => {
          handleSubmit(e);
        }}
      >
        {/* ── Target Type Selector (only shown in add mode) ── */}
        {!editedData && (
          <div className="form-group">
            <label className="fs-16 medium-text">
              Assign To <span className="asterisk">*</span>
            </label>
            <div style={{ display: "flex", gap: "24px", marginTop: "8px" }}>
              {["individual", "store", "branch"].map(type => (
                <label
                  key={type}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    fontWeight: values.targetType === type ? "600" : "normal"
                  }}
                >
                  <input
                    type="radio"
                    name="targetType"
                    value={type}
                    checked={values.targetType === type}
                    onChange={() => {
                      setFieldValue("targetType", type);
                      setFieldValue("device", "");
                      setFieldValue("branchId", "");
                    }}
                  />
                  {type === "individual"
                    ? "Individual Devices"
                    : type === "store"
                    ? `Entire Store${storeName ? ` (${storeName})` : ""}`
                    : "Specific Branch"}
                </label>
              ))}
            </div>
          </div>
        )}

        {/* ── Individual device multi-select ── */}
        {(!editedData && values.targetType === "individual") || editedData ? (
          <div className="form-group">
            <label className="fs-16 medium-text">
              Device <span className="asterisk">*</span>
            </label>
            <Select
              name="device"
              id="device"
              isDisabled={editedData ? true : false}
              placeholder="Select Device"
              value={values.device}
              isMulti={!editedData}
              onChange={data => setFieldValue("device", data)}
              onBlur={handleBlur}
              options={
                deviceList?.length > 0
                  ? deviceList.map(result => ({
                      label: `${result.email}(${result.storeName ??
                        "-"} - ${result.branchName ?? "-"})`,
                      value: result.email,
                      id: result.deviceTokenId
                    }))
                  : []
              }
            />
            <Error field="device" />
          </div>
        ) : null}

        {/* ── Entire Store: informational note, no extra selector needed ── */}
        {!editedData && values.targetType === "store" && (
          <div className="form-group">
            <div
              className="alert alert-info"
              style={{
                padding: "10px 14px",
                borderRadius: "6px",
                background: "#e8f4fd",
                color: "#0c5460",
                border: "1px solid #bee5eb"
              }}
            >
              <i className="fas fa-info-circle mr-6" />
              Banners will be assigned to <strong>all devices</strong> across
              all branches of <strong>{storeName || "this store"}</strong>.
            </div>
          </div>
        )}

        {/* ── Branch dropdown ── */}
        {!editedData && values.targetType === "branch" && (
          <div className="form-group">
            <label className="fs-16 medium-text">
              Branch <span className="asterisk">*</span>
            </label>
            <Select
              name="branchId"
              id="branchId"
              placeholder="Select Branch"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              value={
                branchList.find(
                  b => String(b.branchId) === String(values.branchId)
                )
                  ? {
                      label: branchList.find(
                        b => String(b.branchId) === String(values.branchId)
                      ).branchName,
                      value: values.branchId
                    }
                  : null
              }
              onChange={data => setFieldValue("branchId", data?.value ?? "")}
              onBlur={handleBlur}
              options={branchList.map(b => ({
                label: b.branchName,
                value: b.branchId
              }))}
            />
            {!values.branchId && submitCount > 0 && (
              <span className="error-msg">Branch is required</span>
            )}
          </div>
        )}
        <div className="form-group">
          <label className="fs-16 medium-text">
            Display Time (seconds) <span className="asterisk">*</span>
          </label>
          <input
            type="number"
            className="form-control react-form-input"
            id="bannerDisplayTime"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.bannerDisplayTime}
            placeholder="Seconds"
            onKeyDown={e =>
              (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
            }
            onPaste={e => {
              e.preventDefault();
              return false;
            }}
          />
          <Error field="bannerDisplayTime" />
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">
            Banner <span className="asterisk">*</span>
          </label>
          <div className="file-upload">
            <label className="c-btn c-secondary  form-button fs-16 demi-bold-text mt-15">
              Upload Banner
              <input
                id="banner"
                className="file-upload__input"
                name="file-upload"
                type="file"
                style={{ display: "none" }}
                accept="image/jpeg,image/jpg,image/png,image/webp,video/mp4"
                onChange={e => imageHandler(e)}
                multiple
                onBlur={handleBlur}
              />
            </label>
          </div>
          <Error field="banner" />
        </div>
        <div className="Image-Grid mb-4">
          {imageData.map(result => {
            return (
              <div className="deleteImagebtn pos-relative">
                <div className="button-style">
                  <i
                    className="fa fa-times-circle"
                    onClick={e => {
                      e.preventDefault();
                      let data = imageData;
                      data.splice([data.indexOf(result)], 1);
                      setImageData([...data]);
                      setFieldValue("banner", data);
                    }}
                    style={{
                      backgroundColor: "#fff",
                      color: "black",
                      border: "none",
                      padding: 1,
                      borderRadius: 4
                    }}
                  />
                </div>

                {(result?.bannerFileType &&
                  result?.bannerFileType !== "VIDEO") ||
                (!result?.bannerFileType &&
                  !result?.type &&
                  getExtension(result?.bannerImage) !== "mp4") ||
                (result?.type && result?.type !== "video/mp4") ? (
                  <img
                    alt="loading"
                    src={
                      result?.bannerImage
                        ? result?.bannerImage
                        : URL.createObjectURL(result)
                    }
                    className="Image"
                    style={{
                      width: "320px",
                      borderRadius: "4%",
                      height: "180px",
                      background: "#404040",
                      objectFit: result?.type === "video/mp4" && "contain"
                    }}
                    title={"Image"}
                  />
                ) : (
                  <video
                    autoPlay
                    controls
                    src={
                      result?.bannerImage
                        ? result?.bannerImage
                        : URL.createObjectURL(result)
                    }
                    style={{
                      width: "320px",
                      borderRadius: "4%",
                      height: "180px",
                      background: "#404040"
                    }}
                    onClick={e => {
                      e.preventDefault();
                      let data = imageData;
                      data.splice([data.indexOf(result)], 1);
                      setImageData([...data]);
                      setFieldValue("banner", data);
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
        {isStore && deviceCount === 0 && (
          <div>
            <Button
              className="c-btn mb-12"
              onClick={() => props.history.push("/store/device/add")}
              style={{
                backgroundColor: "#0f172a",
                color: "#fff"
              }}
            >
              <i className="fas fa-plus mr-10"></i>Add Device
            </Button>
          </div>
        )}

        <div>
          <Button
            type="submit"
            loading={loading}
            disabled={loading || (isStore && deviceCount === 0)}
            className="c-btn c-info form-button fs-16 demi-bold-text mr-15"
            style={{ maxWidth: "125px" }}
            dataStyle="expand-right"
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default compose(enhancer)(BannerForm);
